import * as Sentry from '@sentry/react';
import { noop } from 'lodash-es';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const makeMockIntercomClient = () => ({
  boot: noop,
  shutdown: noop,
  showNewMessage: noop
});
export class RealIntercomClient {
  boot(data) {
    this.getIntercom().then(intercom => intercom('boot', data));
  }
  shutdown() {
    this.getIntercom().then(intercom => intercom('shutdown'));
  }
  showNewMessage() {
    this.getIntercom().then(intercom => intercom('showNewMessage'));
  }
  async getIntercom() {
    if (window.enableIntercom && window.isProduction) {
      return window.Intercom || this.loadIntercom();
    } else {
      return () => {};
    }
  }
  loadIntercom() {
    const APP_ID = window._intercom_app_id = 'yx1cchhq';
    return new Promise(resolve => {
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        const d = document;
        const i = function i() {
          // eslint-disable-next-line prefer-rest-params
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        const l = function l() {
          var _x$parentNode;
          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + APP_ID;
          const x = d.getElementsByTagName('script')[0];
          (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 || _x$parentNode.insertBefore(s, x);
          s.onload = () => resolve(window.Intercom);
          s.onerror = error => {
            Sentry.withScope(scope => {
              if (typeof error === 'string') {
                scope.setContext('additional data', {
                  errorString: error
                });
              } else {
                scope.setContext('additional data', {
                  errorEvent: JSON.stringify(error),
                  type: error.type
                });
              }
              Sentry.captureException(new Error('failed to load intercom'));
            });
          };
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    });
  }
}